/* ZOFF product page behaviour -- ported from ZOFF_Product_Page_finalV2.html (30 Sep 2026). Loaded (defer)
   only on product pages by the clean branch of layout/theme.liquid.
   The design's prototype cart, fake lab PDF, pincode demo, Smart Refill and multi-pack % tiers are NOT here:
   the cart is the real Shopify cart through window.ZH (zoff-ui.js); the rest is parked (client, 30 Sep 2026).
   Every block returns early when its section is not on the page. As on the homepage, the design's
   prefers-reduced-motion switches are deliberately not honoured. */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var money = function (paise) { return window.ZH ? window.ZH.money(paise) : '₹' + Math.round(paise / 100); };
  var P = {}; try { P = JSON.parse($('#zp-product').textContent); } catch (_) {}
  var V = P.variants || [];
  var gramsOf = function (v) {
    var m = /(\d+(?:\.\d+)?)\s*(kg|g|gm|gms|gram|grams)\b/i.exec(v.title || '');
    if (m) return parseFloat(m[1]) * (/^kg$/i.test(m[2]) ? 1000 : 1);
    return v.grams || 0;
  };
  var S = { v: Math.max(0, V.map(function (v) { return v.id; }).indexOf(P.selected)), qty: 1 };
  var cur = function () { return V[S.v] || {}; };
  /* Multi-pack offer, from the zp-main 'tiers' setting ('2:5,3:10,6:15'). DISPLAY ONLY for now -- the
     client will switch on the matching Shopify discount later (30 Sep 2026), so the cart still charges list price. */
  var rootEl = $('[data-zp-root]');
  var TIERS = String((rootEl && rootEl.getAttribute('data-tiers')) || '').split(',').map(function (t) { var p = t.split(':'); return { q: parseInt(p[0], 10), off: parseFloat(p[1]) }; }).filter(function (t) { return t.q > 1 && t.off > 0; }).sort(function (a, b) { return a.q - b.q; });
  /* discounted totals are shown in whole rupees, as the design does (prices are in paise) */
  var rup = function (paise) { return Math.round(paise / 100) * 100; };
  var tierOff = function (q) { var o = 0; TIERS.forEach(function (t) { if (q >= t.q) o = t.off; }); return o; };
  var lineTotal = function () { var v = cur(); return rup((v.price || 0) * S.qty * (1 - tierOff(S.qty) / 100)); };
  var listeners = [];
  var onChange = function (fn) { listeners.push(fn); };
  function roll(el, to) {
    if (!el) return;
    var from = +(el.dataset.v || to); el.dataset.v = to;
    if (from === to) { el.textContent = money(to); return; }
    var t0 = performance.now(), d = 520;
    (function f(t) { var k = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - k, 3); el.textContent = money(Math.round(from + (to - from) * e)); if (k < 1) requestAnimationFrame(f); })(t0);
  }
  function addFlash(btn) { if (!btn) return; btn.classList.add('is-added'); clearTimeout(btn._t); btn._t = setTimeout(function () { btn.classList.remove('is-added'); }, 1900); }
  function addToBag(items, btn, label) {
    if (!window.ZH) return Promise.resolve();
    var list = items.filter(function (i) { return i.quantity > 0; });
    if (!list.length) return Promise.resolve();
    if (btn) btn.disabled = true;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { addFlash(btn); window.ZH.toast(label + ' added to your bag.'); return window.ZH.refresh(); })
      .catch(function (e) { window.ZH.toast((e && (e.description || e.message)) || 'Could not add that right now.'); })
      .finally(function () { if (btn) btn.disabled = false; syncButtons(); });
  }

  /* ── Buy box: sizes, quantity, price, CTAs ── */
  var root = $('[data-zp-root]');
  function syncButtons() {
    var v = cur(), off = !v.available;
    ['#add', '#buy-now', '#st-add'].forEach(function (s) { var b = $(s); if (b) b.disabled = off; });
    var al = $('#add-label'); if (al) al.textContent = off ? 'Sold out' : 'Add to bag';
    notifyFor(off ? v : null);
  }
  /* back-in-stock request (2 Nov 2026): shown for a sold-out pick or a tapped sold-out size; kept open after a submit */
  function notifyFor(v, focus) {
    var box = $('#zp-notify'); if (!box) return;
    if (box.querySelector('.zp-notify__ok, .zp-notify__err')) { box.hidden = false; return; }
    box.hidden = !v; if (!v) return;
    var size = box.querySelector('[data-zp-notify-size]'), lab = box.querySelector('[data-zp-notify-label]');
    if (size) size.value = v.title || '';
    if (lab) lab.textContent = V.length > 1 && v.title ? ' in ' + v.title : '';
    if (focus) { var em = $('#zp-notify-email'); if (em) em.focus({ preventScroll: true }); box.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
  }
  function render() {
    var v = cur(); if (!v.id) return;
    roll($('#price'), v.price);
    var mrp = $('#mrp'), offEl = $('#off'), hasMrp = v.compare > v.price;
    if (mrp) { mrp.hidden = !hasMrp; mrp.textContent = hasMrp ? money(v.compare) : ''; }
    if (offEl) { offEl.hidden = !hasMrp; offEl.textContent = hasMrp ? Math.round((1 - v.price / v.compare) * 100) + '% off' : ''; }
    var g = gramsOf(v), per = $('#per100');
    if (per) per.textContent = (g ? money(Math.round(v.price / (g / 100))) + ' / 100 g · ' : '') + 'Incl. of all taxes';
    var off = tierOff(S.qty), line = lineTotal(), base = (hasMrp ? v.compare : v.price) * S.qty;
    roll($('#add-price'), line);
    var am = $('#add-mrp'); if (am) am.textContent = base > line ? money(base) : '';
    var qh = $('#qhint');
    if (qh && TIERS.length) {
      var nt = TIERS.filter(function (t) { return t.q > S.qty; })[0];
      qh.innerHTML = (off ? '<b>' + off + '% off applied.</b> ' : '') + (nt ? '<button type="button" class="qnudge" data-to="' + nt.q + '">Add ' + (nt.q - S.qty) + ' more for ' + nt.off + '%' + (off ? '' : ' off') + '</button>' : '<b>Best price unlocked. Nice.</b>');
    }
    var qt = $('#qtiers'); if (qt) qt.textContent = 'Any ' + TIERS.map(function (t) { return t.q + '+ packs ' + t.off + '%'; }).join(' · ');
    var q = $('#qty'); if (q) q.textContent = S.qty;
    var qd = $('#q-down'), qu = $('#q-up'); if (qd) qd.disabled = S.qty <= 1; if (qu) qu.disabled = S.qty >= 12;
    var st = $('#st-meta'); if (st) st.innerHTML = (V.length > 1 ? v.title + ' · ' : '') + '<b>' + money(v.price) + '</b>';
    var form = $('#zp-form'); if (form) { form.elements.id.value = v.id; form.elements.quantity.value = S.qty; }
    $$('.opt.size').forEach(function (b, i) { b.setAttribute('aria-checked', i === S.v ? 'true' : 'false'); });
    syncButtons(); shipMeter();
    listeners.forEach(function (fn) { fn(v); });
  }
  if (root) {
    $$('.opt.size').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.dataset.i; if (!V[i]) return; // a sold-out size is selectable too (client, 2 Nov): the buttons read Sold out and the notify box opens
        S.v = i; render();
        if (window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', V[i].id); history.replaceState(null, '', u); }
        if (V[i].media) { var sl = $('[data-media-id="' + V[i].media + '"]'); if (sl) goSlide($$('[data-slide]').indexOf(sl)); }
      });
    });
    var qhEl = $('#qhint'); if (qhEl) qhEl.addEventListener('click', function (e) { var n = e.target.closest('.qnudge'); if (!n) return; S.qty = Math.min(12, +n.getAttribute('data-to')); render(); });
    var up = $('#q-up'), dn = $('#q-down');
    if (up) up.addEventListener('click', function () { S.qty = Math.min(12, S.qty + 1); render(); });
    if (dn) dn.addEventListener('click', function () { S.qty = Math.max(1, S.qty - 1); render(); });
    /* 'Best value' on the cheapest-per-gram size, unless that size already carries its own label */
    var bvLabel = rootEl && rootEl.getAttribute('data-best-value');
    if (bvLabel && V.length > 1) {
      var best = -1, bestRate = Infinity;
      V.forEach(function (v, i) { var g = gramsOf(v); if (g && v.available && v.price / g < bestRate - 1e-9) { bestRate = v.price / g; best = i; } });
      var tile = best > -1 && $('.opt.size[data-i="' + best + '"]');
      var anyGrams = V.filter(function (v) { return gramsOf(v); }).length > 1;
      if (tile && anyGrams && !tile.querySelector('.opt__tag')) { var tg = document.createElement('i'); tg.className = 'opt__tag'; tg.textContent = bvLabel; tile.insertBefore(tg, tile.firstChild); }
    }
    var add = function (btn) { var v = cur(); if (!v.available) return; addToBag([{ id: v.id, quantity: S.qty }], btn, P.title + (V.length > 1 ? ' ' + v.title : '')); };
    var addBtn = $('#add'); if (addBtn) addBtn.addEventListener('click', function () { add(addBtn); });
    var stBtn = $('#st-add'); if (stBtn) stBtn.addEventListener('click', function () { add(addBtn); });
    /* Buy now: GoKwik's own buy-now (it reads #zp-form) when it has loaded; otherwise add + checkout */
    var bn = $('#buy-now');
    if (bn) bn.addEventListener('click', function () {
      var v = cur(); if (!v.available) return;
      if (typeof window.onBuyNowClick === 'function' && window.gokwikSdk) {
        var b = document.createElement('button'), l = document.createElement('span'); l.style.display = 'none'; b.appendChild(l);
        window.onBuyNowClick(b); return;
      }
      addToBag([{ id: v.id, quantity: S.qty }], bn, P.title).then(function () { location.href = '/checkout'; });
    });
  }

  /* ── Free-shipping meter: the real cart total (plus this line while the cart is empty) ── */
  var meter = $('#ship-meter'), cartTotal = 0;
  function shipMeter() {
    if (!meter) return;
    var free = +meter.dataset.free, base = cartTotal || lineTotal(), left = Math.max(0, free - base), w = Math.min(100, base / free * 100);
    $('#ship-text').innerHTML = left ? 'Add <strong>' + money(left) + '</strong> more for free shipping' : '<strong>Free shipping unlocked.</strong> Nice.';
    $('#ship-bar').style.width = w + '%';
  }
  function readCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price || 0; shipMeter(); }).catch(function () {}); }
  if (meter) { readCart(); document.addEventListener('visibilitychange', function () { if (!document.hidden) readCart(); }); var f0 = window.fetch; window.fetch = function (i) { var p = f0.apply(this, arguments); var u = typeof i === 'string' ? i : i && i.url; if (/\/cart\/(add|change|update|clear)/.test(String(u))) p.then(function () { setTimeout(readCart, 120); }); return p; }; }

  /* ── Gallery: circle-wipe slides, swipe, tap-to-advance, thumbs, pointer parallax ── */
  var stage = $('#stage'), slides = $$('[data-slide]'), thumbs = $$('.thumb'), cursl = 0, busy = false;
  function goSlide(i, x, y) {
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    if (i === cursl || busy || i < 0) return;
    var from = slides[cursl], to = slides[i];
    to.style.setProperty('--wx', (x == null ? 50 : x) + '%'); to.style.setProperty('--wy', (y == null ? 50 : y) + '%');
    from.classList.remove('is-active'); from.classList.add('is-leaving');
    to.classList.add('is-active', 'is-entering'); busy = true;
    var img = to.querySelector('img'); if (img) img.loading = 'eager';
    setTimeout(function () { from.classList.remove('is-leaving'); to.classList.remove('is-entering'); busy = false; }, 1000);
    cursl = i;
    thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
    /* keep the active thumb in view inside its own scroll row, without moving the page */
    var at = thumbs[i], row = at && at.parentElement;
    if (row && (row.scrollWidth > row.clientWidth || row.scrollHeight > row.clientHeight)) {
      /* desktop thumbs are a column (V4), phones a row: centre the active one on whichever axis scrolls */
      var rr = row.getBoundingClientRect(), ar = at.getBoundingClientRect();
      row.scrollTo({ left: row.scrollLeft + ar.left - rr.left - (row.clientWidth - ar.width) / 2, top: row.scrollTop + ar.top - rr.top - (row.clientHeight - ar.height) / 2, behavior: 'smooth' });
    }
    var num = $('#slide-num'); if (num) num.textContent = ('0' + (i + 1)).slice(-2);
  }
  if (stage && slides.length > 1) {
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goSlide(n); }); });
    var gp = $('#g-prev'), gn = $('#g-next');
    if (gp) gp.addEventListener('click', function () { goSlide(cursl - 1, 12, 50); });
    if (gn) gn.addEventListener('click', function () { goSlide(cursl + 1, 88, 50); });
    stage.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') goSlide(cursl + 1, 88, 50); if (e.key === 'ArrowLeft') goSlide(cursl - 1, 12, 50); });
    var sx = null, sy = 0;
    stage.addEventListener('pointerdown', function (e) { if (e.target.closest('button')) return; sx = e.clientX; sy = e.clientY; });
    stage.addEventListener('pointerup', function (e) {
      if (sx == null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy, r = stage.getBoundingClientRect();
      var px = ((e.clientX - r.left) / r.width) * 100, py = ((e.clientY - r.top) / r.height) * 100;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goSlide(cursl + (dx < 0 ? 1 : -1), px, py);
      else if (Math.abs(dx) < 8 && Math.abs(dy) < 8) goSlide(cursl + 1, px, py);
      sx = null;
    });
    /* warm the next images once the page is idle so the first wipe never lands on a blank slide */
    window.addEventListener('load', function () { setTimeout(function () { slides.forEach(function (s) { var im = s.querySelector('img'); if (im) { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); } }); }, 1200); });
  }
  var packWrap = $('#hero-pack');
  if (stage && packWrap && fine) {
    stage.addEventListener('pointermove', function (e) { var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; packWrap.style.setProperty('--px', (x * 22).toFixed(1) + 'px'); packWrap.style.setProperty('--py', (y * 16).toFixed(1) + 'px'); packWrap.style.setProperty('--pr', (x * 6).toFixed(2) + 'deg'); });
    stage.addEventListener('pointerleave', function () { ['--px', '--py', '--pr'].forEach(function (p) { packWrap.style.setProperty(p, p === '--pr' ? '0deg' : '0px'); }); });
  }

  /* ── Wishlist heart: the same localStorage list the theme's wishlist page reads ('wishlistItem', handles) ── */
  var wish = $('#wish');
  if (wish) {
    var read = function () { try { return JSON.parse(localStorage.getItem('wishlistItem') || '[]'); } catch (_) { return []; } };
    var paint = function () { var on = read().indexOf(P.handle) > -1; wish.classList.toggle('is-on', on); wish.setAttribute('aria-pressed', on ? 'true' : 'false'); };
    wish.addEventListener('click', function (e) {
      e.stopPropagation();
      var list = read(), i = list.indexOf(P.handle);
      if (i > -1) list.splice(i, 1); else list.push(P.handle);
      try { localStorage.setItem('wishlistItem', JSON.stringify(list)); } catch (_) {}
      paint(); if (window.ZH) window.ZH.toast(i > -1 ? 'Removed from wishlist' : 'Saved to wishlist');
    });
    paint();
  }

  /* ── Sticky add-to-bag: shows once the main CTA scrolls away, hides over the footer ── */
  var sticky = $('#sticky'), cta = $('#buy-cta'), foot = $('.fs-ft') || $('.zh-footer');
  if (sticky && cta && 'IntersectionObserver' in window) {
    var ctaVis = true, footVis = false;
    var state = function () { var on = !ctaVis && !footVis && cta.getBoundingClientRect().top < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      /* the add-to-bag toast lifts above the bar while it shows (zp-main reads these on <html>) */
      document.documentElement.classList.toggle('zp-sticky-on', on); if (on) document.documentElement.style.setProperty('--zp-sticky-h', sticky.offsetHeight + 'px'); var b = $('#st-add'); if (b) b.tabIndex = on ? 0 : -1; };
    new IntersectionObserver(function (en) { ctaVis = en[0].isIntersecting; state(); }).observe(cta);
    if (foot) new IntersectionObserver(function (en) { footVis = en[0].isIntersecting; state(); }).observe(foot);
    window.addEventListener('scroll', function () { requestAnimationFrame(state); }, { passive: true });
  }

  /* ── Frequently bought together ── */
  var bundle = $('#bundle');
  if (bundle) {
    var items = $$('.fbt-item', bundle), bAdd = $('#b-add');
    var sum = function () {
      var sel = items.filter(function (b) { return b.querySelector('input').checked; });
      items.forEach(function (b) { b.classList.toggle('is-off', !b.querySelector('input').checked); });
      var raw = sel.reduce(function (t, b) { return t + +b.dataset.price; }, 0), pct = TIERS.length ? tierOff(sel.length) : (+bundle.getAttribute('data-discount') || 0), disc = pct > 0 && sel.length >= 2, tot = disc ? rup(raw * (1 - pct / 100)) : raw;
      $('#b-count').textContent = sel.length ? 'Total for ' + sel.length + (sel.length === 1 ? ' item' : ' items') : 'No items selected';
      roll($('#b-total'), tot);
      var bm = $('#b-mrp'); if (bm) { bm.hidden = !disc; bm.textContent = disc ? money(raw) : ''; }
      var nextPct = TIERS.length ? tierOff(sel.length + 1) : pct;
      var bs = $('#b-save'); if (bs) { bs.hidden = !(pct || nextPct); bs.textContent = disc ? 'You save ' + money(raw - tot) + ' · ' + pct + '% off' : sel.length ? 'Tick one more to save ' + nextPct + '%' : 'Tick an item to add it'; }
      $('#b-add-label').textContent = sel.length ? 'Add selected items to bag' : 'Select an item';
      bAdd.disabled = !sel.length;
      return sel;
    };
    items.forEach(function (b) { b.querySelector('input').addEventListener('change', sum); });
    onChange(function (v) { var m = $('.fbt-item[data-main]', bundle); if (m) { m.dataset.variant = v.id; m.dataset.price = v.price; var pr = $('[data-main-price]', m); if (pr) pr.textContent = money(v.price); } sum(); });
    bAdd.addEventListener('click', function () { var sel = sum(); addToBag(sel.map(function (b) { return { id: +b.dataset.variant, quantity: 1 }; }), bAdd, sel.length + (sel.length === 1 ? ' item' : ' items')); });
    sum();
  }

  /* ── Usage calculator (common): days a pack lasts at the selected size ── */
  var calcSec = $('#calc');
  if (calcSec) {
    var C = { freq: 1, home: 1, packs: 0 }, BASE = +calcSec.dataset.base || 8;
    var lasts = function (g) { return Math.max(4, Math.round(g / (BASE * C.freq * C.home))); };
    var rec = function (d) { return [2, 3, 6].filter(function (p) { return p * d >= 60; })[0] || 6; };
    var calc = function () {
      var v = cur(), g = gramsOf(v);
      calcSec.hidden = !g; if (!g) return;
      var d = lasts(g), r = rec(d), p = C.packs || r, full = v.price * p, off = tierOff(p), tot = off ? rup(full * (1 - off / 100)) : full;
      $('#c-size').textContent = g >= 1000 ? (g / 1000) + ' kg' : g + ' g';
      $('#c-days').textContent = d;
      $$('.stock button', calcSec).forEach(function (b) { var n = +b.dataset.p; b.setAttribute('aria-checked', n === p ? 'true' : 'false'); b.classList.toggle('is-rec', n === r); b.querySelector('[data-d]').textContent = n * d + ' days'; var o = tierOff(n), em = b.querySelector('em'); if (o) { if (!em) { em = document.createElement('em'); b.appendChild(em); } em.textContent = o + '% off'; } else if (em) em.remove(); });
      $('#c-add-label').textContent = v.available ? 'Add ' + p + (p === 1 ? ' pack' : ' packs') + ' · ' + money(tot) : 'Sold out';
      $('#c-add').disabled = !v.available;
      $('#c-save').textContent = p * d + ' days covered' + (full > tot ? ' · you save ' + money(full - tot) : (TIERS.length ? ' · add ' + TIERS[0].q + '+ packs to save' : ''));
      calc.p = p;
    };
    $$('.seg', calcSec).forEach(function (seg) {
      var btns = $$('button', seg);
      btns.forEach(function (b, i) {
        if (b.getAttribute('aria-checked') === 'true') seg.style.setProperty('--i', i);
        b.addEventListener('click', function () { btns.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); }); seg.style.setProperty('--i', i); C[seg.dataset.calc] = +b.dataset.v; C.packs = 0; calc(); });
      });
    });
    $$('.stock button', calcSec).forEach(function (b) { b.addEventListener('click', function () { C.packs = +b.dataset.p; calc(); }); });
    $('#c-add').addEventListener('click', function () { var v = cur(); addToBag([{ id: v.id, quantity: calc.p }], $('#c-add'), calc.p + (calc.p === 1 ? ' pack' : ' packs')); });
    onChange(calc); calc();
  }

  /* ── Recipe rail progress ── */
  var rail = $('#recipe-rail'), bar = $('#recipe-bar');
  if (rail && bar) {
    var n = rail.children.length || 4; bar.style.width = (100 / n) + '%';
    rail.addEventListener('scroll', function () { var m = rail.scrollWidth - rail.clientWidth; bar.style.transform = 'translateX(' + (m > 0 ? rail.scrollLeft / m * (n - 1) * 100 : 0) + '%)'; }, { passive: true });
  }

  /* ── Veda: drifting motes, tilt, flip ── */
  var veda = $('#veda');
  if (veda) {
    var cols = ['#c9a44a', '#8fa876', '#b5733d', '#e0c77a', '#7c9464'];
    for (var i = 0; i < 16; i++) {
      var m = document.createElement('span'); m.className = 'veda-mote'; m.setAttribute('aria-hidden', 'true');
      m.style.cssText = 'left:' + (Math.random() * 100).toFixed(1) + '%;--s:' + (3 + Math.random() * 5).toFixed(1) + 'px;--c:' + cols[i % 5] + ';--t:' + (10 + Math.random() * 9).toFixed(1) + 's;--dl:-' + (Math.random() * 14).toFixed(1) + 's;--dx:' + (Math.random() * 60 - 30).toFixed(0) + 'px;--o:' + (.35 + Math.random() * .4).toFixed(2);
      veda.appendChild(m);
    }
    $$('.ritual', veda).forEach(function (c) {
      var inner = $('.ritual__inner', c);
      var flip = function () { var on = !c.classList.contains('is-flipped'); c.classList.toggle('is-flipped', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); };
      c.addEventListener('click', flip);
      c.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); flip(); } });
      if (fine) {
        c.addEventListener('pointermove', function (e) { var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height; inner.style.setProperty('--ry', ((x - .5) * 10).toFixed(2) + 'deg'); inner.style.setProperty('--rx', ((.5 - y) * 8).toFixed(2) + 'deg'); $$('.ritual__face', c).forEach(function (f) { f.style.setProperty('--mx', x * 100 + '%'); f.style.setProperty('--my', y * 100 + '%'); }); });
        c.addEventListener('pointerleave', function () { inner.style.setProperty('--rx', '0deg'); inner.style.setProperty('--ry', '0deg'); });
      }
    });
    var tick = false;
    window.addEventListener('scroll', function () { if (tick) return; tick = true; requestAnimationFrame(function () { var vr = veda.getBoundingClientRect(); veda.style.setProperty('--vp', Math.max(-1.2, Math.min(1.2, ((vr.top + vr.height / 2) - innerHeight / 2) / innerHeight)).toFixed(3)); tick = false; }); }, { passive: true });
  }

  /* ── Related: Shopify recommendations, fetched once the section nears the viewport ── */
  var rel = $('[data-zp-recs]');
  if (rel && !rel.children.length) {
    var load = function () {
      fetch(rel.getAttribute('data-zp-recs')).then(function (r) { return r.text(); }).then(function (html) {
        var t = document.createElement('div'); t.innerHTML = html;
        var fresh = t.querySelector('[data-zp-recs]');
        if (fresh && fresh.children.length) { rel.innerHTML = fresh.innerHTML; rel.hidden = false; }
      }).catch(function () {});
    };
    /* the shell is [hidden] (display:none) until it has products, so an IntersectionObserver on it would
       never fire -- fetch once the page has finished loading instead, off the critical path */
    var later = function () { setTimeout(load, 300); };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  }

  if (root) render();

  /* ── Pincode check (client flow, 1 Oct 2026). Lists come from assets/zp-pincodes.json, built from the
     courier sheet (Zoff-pinocdes.xlsx), fetched only when someone checks a pincode:
     S = within-city, same-day ("SDD-INV YES")  -> before the cut-off: today, after: tomorrow
     N = within-city, no same-day ("SDD-INV NO") and R = regional NDD cities -> before: T+1, after: T+2
     anything else -> we can't deliver there. 16 Oct 2026 (client): the quick-commerce list stays hidden until a
     checked pincode is not served or would take more than 2 days; then it shows, highlighted.
     Times are IST whatever the shopper's clock says; the cut-off hour is the section setting. ── */
  var dlv = $('#zp-delivery');
  if (dlv) {
    var pinIn = $('#pin', dlv), pinOut = $('#pin-result', dlv), qcBox = $('#qcomm', dlv), pinForm = $('#pin-form', dlv);
    var cutoff = +dlv.getAttribute('data-cutoff') || 11, pinMap = null;
    var loadPins = function () {
      if (!pinMap) pinMap = fetch(dlv.getAttribute('data-pin-src')).then(function (r) { return r.json(); }).then(function (j) {
        var m = {};
        ['S', 'N', 'R'].forEach(function (k) { var o = j[k] || {}; Object.keys(o).forEach(function (city) { o[city].split(' ').forEach(function (p) { m[p] = [k, city]; }); }); });
        return m;
      });
      return pinMap;
    };
    var ist = function () { var d = new Date(); return new Date(d.getTime() + (d.getTimezoneOffset() + 330) * 60000); };
    var day = function (n) { var d = ist(); d.setDate(d.getDate() + n); return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var hourLbl = function (h) { return (h % 12 || 12) + (h < 12 ? ' AM' : ' PM'); };
    var leftLbl = function (now) { var m = cutoff * 60 - (now.getHours() * 60 + now.getMinutes()), h = Math.floor(m / 60); return (h ? h + (h > 1 ? ' hrs ' : ' hr ') : '') + (m % 60) + ' min'; };
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var change = '<button type="button" data-change>Change</button>';
    /* the apps show only when they help: a pincode we cannot serve, or a delivery slower than 2 days */
    var qcShow = function (on) { if (!qcBox) return; qcBox.hidden = !on; qcBox.classList.toggle('is-focus', !!on); var l = qcBox.querySelector('.qcomm__lead'); if (l) l.textContent = qcBox.getAttribute(on ? 'data-lead-focus' : 'data-lead'); };
    var check = function (val) {
      if (!/^\d{6}$/.test(val)) {
        pinForm.classList.remove('is-error'); void pinForm.offsetWidth; pinForm.classList.add('is-error');
        pinOut.innerHTML = '<p class="pin-res pin-res--err">Please enter a valid 6-digit pincode.</p>'; qcShow(false); pinIn.focus(); return;
      }
      pinForm.classList.remove('is-error');
      loadPins().then(function (map) {
        var hit = map[val], now = ist(), before = now.getHours() < cutoff, cut = hourLbl(cutoff);
        try { localStorage.setItem('zp-pin', val); } catch (_) {}
        if (!hit) {
          pinOut.innerHTML = '<div class="pin-res pin-res--no"><svg class="icon"><use href="#i-pin"/></svg><div><strong>We do not deliver to this pincode yet.</strong><small>' + (qcBox ? 'No stress, grab it in minutes on an app below · ' : '') + change + '</small></div></div>';
          qcShow(true); return;
        }
        var same = hit[0] === 'S', days = same ? (before ? 0 : 1) : (before ? 1 : 2);
        var when = days === 0 ? 'today, ' + day(0) : days === 1 ? 'tomorrow, ' + day(1) : day(days);
        var note = before
          ? 'Order in the next ' + leftLbl(now) + ' to get it ' + (same ? 'today' : 'tomorrow')
          : (same ? 'Same-day delivery on orders before ' : 'Next-day delivery on orders before ') + cut;
        pinOut.innerHTML = '<div class="pin-res pin-res--ok"><svg class="icon"><use href="#i-check"/></svg><div><strong>We deliver to ' + val + ', ' + esc(hit[1]) + '</strong> · arrives ' + when + '<small>' + note + ' · COD available · ' + change + '</small></div></div>';
        qcShow(days > 2);
      }).catch(function () { pinOut.innerHTML = '<p class="pin-res pin-res--err">Couldn’t check right now. Please try again.</p>'; pinMap = null; });
    };
    pinForm.addEventListener('submit', function (e) { e.preventDefault(); check(pinIn.value.trim()); });
    pinIn.addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').slice(0, 6); });
    pinIn.addEventListener('focus', loadPins, { once: true });
    pinOut.addEventListener('click', function (e) { if (e.target.closest('[data-change]')) { pinOut.innerHTML = ''; qcShow(false); pinIn.select(); pinIn.focus(); } });
    var saved = null; try { saved = localStorage.getItem('zp-pin'); } catch (_) {}
    if (saved && /^\d{6}$/.test(saved)) { pinIn.value = saved; check(saved); }
  }

  /* ── One open toggle per page: opening any <details> (details accordion, FAQ) closes the others.
     'toggle' does not bubble, so listen in the capture phase. ── */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    $$('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);
})();
